import React from 'react';
import styled from '@emotion/styled';
import { text } from 'style/mixin';
import fonts from 'style/fonts';
import { TitleContentRow } from 'components/unique/careerDetail/titleContentRow';
import { mq } from 'style/variables';

const SkillsContentTitle = styled.h3`
  ${text(20, 1.44, true)}
  font-weight: 600;
  font-family: ${fonts.jaGothic};
  letter-spacing: 0.1rem;
  text-align: justify;
  margin-top: 10px;
  padding: 0 2px;

  p + & {
    margin-top: 34px;

    ${mq.onlysp} {
      margin-top: 36px;
    }
  }

  ${mq.onlysp} {
    ${text(17, 1.8)}
    margin-top: 13px;
  }
`;

const SkillsContentText = styled.p`
  ${text(18, 1.6)}
  font-weight: 500;
  font-family: ${fonts.jaGothic};
  letter-spacing: 0.1rem;
  text-align: justify;
  white-space: pre-wrap;
  margin-top: 9px;
  padding: 0 2px;

  ${mq.onlysp} {
    ${text(14, 1.55)}
    margin-top: 16px;
    margin-bottom: 9px;
  }
`;

type CareerDetailSkillsProps = {
  skillsRequired?: string;
  skillsPreferred?: string;
};

export const CareerDetailSkills = ({ skillsRequired, skillsPreferred }: CareerDetailSkillsProps) => {
  return (
    <TitleContentRow titleEn="Skills" titleJa="スキル">
      {skillsRequired && (
        <>
          <SkillsContentTitle>必須スキル</SkillsContentTitle>
          <SkillsContentText dangerouslySetInnerHTML={{ __html: skillsRequired }} />
        </>
      )}
      {skillsPreferred && (
        <>
          <SkillsContentTitle>歓迎スキル</SkillsContentTitle>
          <SkillsContentText dangerouslySetInnerHTML={{ __html: skillsPreferred }} />
        </>
      )}
    </TitleContentRow>
  );
};
